import { render, staticRenderFns } from "./MatchesList.vue?vue&type=template&id=242889d4&scoped=true&"
import script from "./MatchesList.vue?vue&type=script&lang=js&"
export * from "./MatchesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242889d4",
  null
  
)

export default component.exports